/* eslint-disable prettier/prettier */
import { Route, Switch } from 'react-router-dom';

import { loadable } from '~/util/routeUtils';

import ClientRouter from '../ClientRouter';

const ImageDetail = loadable(() => import('~/pages/weddings/ImageDetail/ImageDetail'));
const LandingPage = loadable(() => import('~/pages/weddings/LandingPage/LandingPage'));
const NoMatch = loadable(() => import('~/pages/NoMatch/NoMatch'));
const SearchResults = loadable(() => import('~/pages/weddings/SearchResults/SearchResults'));
const WeddingAlbumDetail = loadable(() => import('~/pages/weddings/WeddingAlbumDetail/WeddingAlbumDetail'));

const WeddingsRoutes = () => (
  <ClientRouter>
    <Switch>
      <Route exact path="/inspiration" component={LandingPage} />
      <Route exact={false} path="/inspiration/real-weddings/:slug" component={SearchResults} />
      <Route exact path="/inspiration/photo/:slug([0-9A-Za-z-]+)" component={ImageDetail} />
      <Route exact path="/inspiration/wedding/:slug([0-9A-Za-z-]+)" component={WeddingAlbumDetail} />
      <Route component={NoMatch} />
    </Switch>
  </ClientRouter>
);

export default WeddingsRoutes;
